(() => {
	// preloader js
	const loader = document.querySelector("#preloader");
	if (loader) {
		window.addEventListener("load", () => {
			loader.classList.add("hidden");
		});
	}
})();
